import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import './user-image.scss';
import UserInfo from '../user-info/user-info';
import {
  AcceptedExpenceApproval,
  ExternalOrg,
  PendingExpenceApproval,
  RejectedExpenceApproval,
} from '../icons/pricing-icons';
import { StarIcon } from '../icons/my-company';
import Tooltip from '../tooltip/tooltip';

export default function UserImage({
  size = 'small' ||
    'x-large' ||
    'large' ||
    'x-medium' ||
    'medium' ||
    'x-small' ||
    'xx-small',
  path,
  name,
  removeTooltip,
  marginRight,
  shortName,
  email,
  infoDirection,
  userRole,
  verified,
  type,
  className,
  statusIcon,
  status,
  externalOrg,
  extraInfo,
  extraInfoTooltip,
}) {
  const [imageSize, setImageSize] = useState('');
  const [colorCode, setColorCode] = useState('');
  useEffect(() => {
    switch (size) {
      case 'x-large':
        setImageSize('x-large');
        break;
      case 'large':
        setImageSize('large');
        break;
      case 'x-medium':
        setImageSize('x-medium');
        break;
      case 'medium':
        setImageSize('medium');
        break;
      case 'small':
        setImageSize('small');
        break;
      case 'x-small':
        setImageSize('x-small');
        break;
      case 'xx-small':
        setImageSize('xx-small');
        break;
      default:
        setImageSize('');
    }
  }, [size]);
  useEffect(() => {
    const colorIns = shortName?.split('');
    setColorCode(colorIns?.shift()?.toLowerCase());
  });

  const renderStatusIcon = () => {
    if (!statusIcon) return null;

    switch (status) {
      case 'Pending':
      case 'pending':
      case 'hold':
        return <PendingExpenceApproval />;
      case 'Approved':
      case 'upload':
      case 'Accepted':
        return <AcceptedExpenceApproval />;
      case 'Rejected':
      case 'decline':
        return <RejectedExpenceApproval />;
      default:
        return null;
    }
  };

  return (
    <span
      style={{ marginRight: `${marginRight}` }}
      className="user-image-container"
      data-cy="user-image-container"
    >
      {statusIcon && <span className="status-icon">{renderStatusIcon()}</span>}
      {externalOrg && (
        <span className="external-org-icon">
          <ExternalOrg />
        </span>
      )}
      {extraInfo && (
        <span className="extra-info">
          <Tooltip content={extraInfoTooltip}>
            <StarIcon size="0.417vw" color="#ffffff" />
          </Tooltip>
        </span>
      )}

      {!removeTooltip ? (
        <UserInfo
          userName={name}
          shortName={shortName}
          userUrl={path}
          userEmail={email}
          userRole={userRole}
          direction={infoDirection}
        >
          {path ? (
            <span
              className={`thumb-image ${imageSize} ${
                !verified && 'unverified'
              }${type}`}
            >
              <img src={path} alt="" />
            </span>
          ) : (
            <span
              className={`thumb-sm ${imageSize} ${colorCode} ${
                !verified && 'unverified'
              }${type}`}
            >
              <span>{shortName}</span>
            </span>
          )}
        </UserInfo>
      ) : (
        <>
          {path && (
            <span className={`thumb-image ${imageSize} ${type} ${className}`}>
              <img src={path} alt="" />
            </span>
          )}
          {!path && (
            <span
              className={`thumb-sm ${imageSize} ${colorCode} ${type} ${className}`}
            >
              <span>{shortName}</span>
            </span>
          )}
        </>
      )}
    </span>
  );
}
UserImage.propTypes = {
  size: PropTypes.string,
  path: PropTypes.string,
  name: PropTypes.string,
  removeTooltip: PropTypes.bool,
  marginRight: PropTypes.string,
  shortName: PropTypes.string,
  email: PropTypes.string,
  infoDirection: PropTypes.string,
  userRole: PropTypes.string,
  verified: PropTypes.bool,
  type: PropTypes.string,
  className: PropTypes.string,
  statusIcon: PropTypes.bool,
  status: PropTypes.oneOf(['pending', 'accepted', 'rejected']),
  externalOrg: PropTypes.bool,
  extraInfo: PropTypes.bool,
  extraInfoTooltip: PropTypes.string,
};
UserImage.defaultProps = {
  size: 'small',
  path: '',
  name: '',
  removeTooltip: false,
  marginRight: '',
  shortName: '',
  email: '',
  infoDirection: '',
  userRole: '',
  verified: true,
  type: '',
  className: '',
  statusIcon: false,
  status: 'pending',
  externalOrg: false,
  extraInfo: false,
  extraInfoTooltip: '',
};
